import React, { useEffect, useState } from 'react';
import { Form, Select, Spin } from 'antd';
import Button from '../../../components/Button/Button';
import FormItem, { FileFormItem } from '../../../components/FormItem/FormItem';
import { useNavigate  } from 'react-router-dom';

import styles from './CreateBook.module.scss';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';
import { createBook } from '../../../service/book';
import FileInput from '../../../components/FileInput/FileInput';
import Input from '../../../components/Input/Input';
import { uploadBookImage } from '../../../service/files';
import TextArea from 'antd/lib/input/TextArea';
import { createBookGenres, getAllGenres } from '../../../service/genres';
import { useQuery } from 'react-query';

import ImageInput from '../../../components/ImageInput/ImageInput';
import useHeader from '../../../hooks/useHeader';

const { Option } = Select;

const CreateBook = () => {
  const [form] = Form.useForm();
  
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate();

  useHeader({ header: 'Criar Livros' });

  const {data: genres, isFetching} = useQuery(
    ['genres'],
    () => getAllGenres(),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const onFinish = async (payload) => {
    if(loading) return

    setLoading(true)

    const {error, success} = await createBook(payload)

    setLoading(false)
      
    if(error) {
      return createErrorNotification(error);
    }

    if(payload.genres) { 
      await createBookGenres(success.id, payload.genres)
    }

    delete payload.genres

    if(payload.file){
        const {error: errorFile} = await uploadBookImage(success.id, payload)
        if(errorFile)
          createErrorNotification(errorFile)
    }
      
    setLoading(false)

    createSuccessNotification('Livro criado!')

    navigate(`/book/local/${success.id}`);
  }

  return(
    <div className={styles.container}>
      <div className={styles.maskContainer}></div>
        <div className={styles.createContainer}>
        <Spin spinning={loading}>
          <div className={styles.createForm}>
            <Form 
              layout="vertical" 
              form={form}
              onFinish={onFinish}
              id="formLogin" 
              className={styles.FormContainer}
            >
              <h2 className={styles.title}>Criar novo livro</h2>
              <FormItem
                label="Título"
                name="name"
                rules={[
                  {
                    required: true,
                    message: 'Por favor, digite um título.',
                  },
                  {
                    max: 255,
                    message: 'Título deve ter entre 1 e 255 caracteres.',
                  }
                ]}
                required
              >
                <Input style={styles.input} placeholder="Título do livro"/>
              </FormItem>
              <FormItem
                label="Autor"
                name="author"
                required
                >
                <Input style={styles.input} placeholder="Autor"/>
              </FormItem>
              <FormItem
                label="Descrição"
                name="description"
                >
                <TextArea className={styles.input} placeholder="Descrição"/>
              </FormItem>
              <FormItem
                label="Gêneros Literários do Livro"
                name="genres">
                <Select
                  style={{width: '100%'}}
                  mode="multiple">
                  { 
                    genres?.map(genre => {
                      return <Option value={genre.id}>{genre.content}</Option>
                    })
                  }
                </Select>
              </FormItem>
              <FormItem
                label="ISBN"
                name="isbn"
                rules={[
                  {
                    max: 20,
                    message: 'ISBN deve ter entre 0 e 20 caracteres.',
                  }
                ]}
                >
                <Input style={styles.input} placeholder="ISBN"/>
              </FormItem>
              <FormItem
                label="Páginas"
                name="page"
                rules={[
                  {
                    max: 11,
                    message: 'Páginas deve ser entre 0 e 11 caracteres.',
                  }
                ]}
                >
                <Input type='number' style={styles.input} placeholder="Páginas"/>
              </FormItem>
              <FileFormItem
                name="file"
                label="Capa do Livro"
                >
                <ImageInput
                  height={162}
                  width={130}
                  accept='image/*'
                  onChangeFile={(file)=>{
                    form.setFields([
                      {name: 'file', value: file},
                    ]);
                
                    form.validateFields(['file']);
                  }}
                />
              </FileFormItem>
              <Spin spinning={loading}>
                <Button submit style={styles.button}>Criar Livro</Button>
              </Spin>
            </Form>
          </div>
        </Spin>
      </div>
    </div>
  )
}

export default CreateBook;